import React from 'react';
import { DisplayValue } from '../Models/Valg';
import SelectOptionDisplay from './SelectOptionComponent';
import VeilederStegComponent, { VeilederStegBaseProps, VeilederStegDefaultProps } from './VeilederStegComponent';
import Valg from '../Models/Valg';
import { connect } from 'react-redux';
import { AppState } from '../Store/Types';
import { StegVisning } from '../Store/StegVisning/Types';
import { setCollapsed } from '../Store/StegVisning/Actions';

type SelectOptionsDisplayOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    options: DisplayValue[],
    ledetekst: JSX.Element | null,
    onSelectChange: any,
    showSearch?: boolean,
    value?: Valg<string>,
}

type SelectOptionsDisplayProps = SelectOptionsDisplayOwnProps & MapStateToProps & MapDispatchToProps;

function SelectOptionStegDisplay(props: SelectOptionsDisplayProps): JSX.Element {
    function handleOnSelectChange(valg: Valg<string>) {
        props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:true})
        props.onSelectChange(valg);
    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={props.forklaring}
            canCollapse={props.value != null}
            displayElement={<div className="c-veileder__valgt-item">
                <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
            </div>}
            inputArea={<div className="c-veileder__inputomrade">
                <SelectOptionDisplay
                    htmlId={props.sporsmalId+'-select'}
                    ledetekst={props.ledetekst}
                    options={props.options}
                    onSelectChange={handleOnSelectChange}
                    showSearch={props.showSearch}
                    value={props.value}
                />
            </div>}
            sporsmalId={props.sporsmalId}
        />
    );
}

interface MapStateToProps {
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: AppState, ownProps: SelectOptionsDisplayOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(SelectOptionStegDisplay);